import { ExternalLink } from "lucide-react";

const OPTIONS = [
  { id: "cashapp", name: "Cash App", handle: "$FaneneAulani", owner: "Kimberly Fanene", img: "/images/qr-cashapp.png", url: "https://cash.app/$FaneneAulani" },
  { id: "venmo", name: "Venmo", handle: "@Aulani-Fanene", owner: "Aulani Fanene", img: "/images/qr-venmo.png", url: "https://venmo.com/code?user_id=2304624832806912086&created=1790702662.09267" },
  { id: "bluevine", name: "Payment link", handle: "2027 Fanene funds", owner: "For reunion", img: "/images/qr-bluevine.png", url: "https://pay.bluevine.com/p/4c8dc20c8af44556912aa263e769801c" },
];

export default function PayQRCodes() {
  return (
    <div data-testid="pay-qr-codes">
      <p className="text-lg mb-3">Scan with your phone camera, or tap the button if you're on your phone. Put your household name in the payment note.</p>
      <div className="grid sm:grid-cols-3 gap-4">
        {OPTIONS.map((o) => (
          <div key={o.id} data-testid={`pay-qr-${o.id}`} className="rounded-2xl border-2 border-[#E6DBCF] bg-white p-4 flex flex-col items-center text-center">
            <p className="font-heading text-xl font-bold">{o.name}</p>
            <p className="font-semibold text-[#2B5338]">{o.handle}</p>
            <p className="text-sm text-stone-600">{o.owner}</p>
            <img src={o.img} alt={`${o.name} QR code`} className="w-44 h-44 object-contain my-3" />
            <a href={o.url} target="_blank" rel="noopener noreferrer" data-testid={`pay-link-${o.id}`} className="btn-outline w-full !min-h-[48px] !px-4 whitespace-nowrap">
              <ExternalLink className="w-4 h-4" />Open
            </a>
          </div>
        ))}
      </div>
    </div>
  );
}
